import angular from 'angular'
import inputRuleCtrl from './inputRuleCtrl'
import autoSelectCtrl from './autoSelectCtrl'
import proofreadRuleCtrl from './proofreadRuleCtrl'

import inputRuleTemplate from './view/inputRule.html'
import proofreadRule from './view/proofreadRule.html'
import autoSelect from './view/autoSelect.html'

export default angular
    .module('system.settingcenter.inputRule', [])
    .config(['$stateProvider', function config($stateProvider) {
        $stateProvider
            .state('system.settingcenter.inputRule', {
                abstract: true,
                url: '/inputRule',
                template: '<div ui-view></div>',
                title: '进项规则',
                default: 'system.settingcenter.inputRule.list',
            })
            .state('system.settingcenter.inputRule.list', {
                url: '/list',
                template: inputRuleTemplate,
                controller: 'inputRuleCtrl',
            })
            .state('system.settingcenter.inputRule.autoSelect', {
                url: '/autoSelect',
                template: autoSelect,
                controller: 'autoSelectCtrl',
                title: '自动勾选',
            })
            .state('system.settingcenter.inputRule.proofreadRule', {
                url: '/proofreadRule',
                template: proofreadRule,
                controller: 'proofreadRuleCtrl',
                title: '发票校对',
            })
    }])
    .controller('inputRuleCtrl', inputRuleCtrl)
    .controller('autoSelectCtrl', autoSelectCtrl)
    .controller('proofreadRuleCtrl', proofreadRuleCtrl)
    .name



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/inputRule/index.js